module.exports = __webpack_public_path__ + "media/images/flags/TO-ab403b7d2b205bd3457ce3b8cf08c947.svg";